const getAllStoresReducer = (state = null, action) => {
    switch (action.type) {
        case "GET_ALLSTORES":
            return action.payload;
        default:
            return state;
    }
};
export default getAllStoresReducer;
